import Header from "../HomePage/header";
import Footer from "../HomePage/footer";

const TermsAndConditionsPage = () => {
  return (
    <>
      <Header />
      <div
        className="h-[150px] w-full bg-cover bg-center bg-no-repeat md:h-[350px]"
        style={{
          backgroundImage: `
      linear-gradient(
        270deg,
        rgba(255, 255, 255, 0) 10.52%,
        rgba(34, 55, 51, 0.56) 51.88%,
        rgba(18, 46, 41, 0.94) 100%
      ),
      url('/assets/terms-conditions-banner.png')
    `,
        }}
      >
        <div className="container mx-auto h-full px-4 md:px-0">
          <div className="flex h-full items-center">
            <h1 className="font-nunito text-[20px] font-bold text-white md:text-[40px]">
              Terms & Conditions
            </h1>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-5 md:px-0 md:py-10">
        <div className="">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            1. Acceptance of Terms
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            By accessing or using MNCL digital platforms (“Portal”), you agree
            to be bound by these Terms & Conditions.
          </p>
        </div>

        <div className="mt-3 md:mt-6">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            2. Services
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            The Portal provides online access to MNCL services, investment
            operations, financial information, and related functionalities. MNCL
            reserves the right to modify or discontinue services.
          </p>
        </div>

        <div className="mt-3 md:mt-6">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            3. User Responsibilities
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            Users must :
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Provide accurate information.
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Maintain confidentiality of login credentials.
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Not misuse or attempt to bypass security systems
          </p>
        </div>

        <div className="mt-3 md:mt-6">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            4.Use of Data
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            By using the Portal, you consent to MNCL processing your personal
            data as described in the Privacy Policy.
          </p>
        </div>

        <div className="mt-3 md:mt-6">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            5. Compliance
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            Users must comply with Indian laws including PFRDA regulations, DPDP
            Act, IT Act and other applicable guidelines.
          </p>
        </div>

        <div className="mt-3 md:mt-6">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            6. Limitation of Liability
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            MNCL is not responsible for:
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Losses due to incorrect data entered by the user. .
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Downtime caused by external service providers. .
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Unauthorized access caused by user negligence.
          </p>
        </div>

        <div className="mt-3 md:mt-6">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            7. Intellectual Property
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            All content, trademarks, logos, and designs on the Portal belong to
            MNCL
          </p>
        </div>

        <div className="mt-3 md:mt-6">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            8. Termination
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            MNCL may suspend or terminate user access for violations of these
            Terms.
          </p>
        </div>

        <div className="mt-3 md:mt-6">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            9. Governing Law
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            These Terms are governed by the laws of India.
          </p>
        </div>

        <div className="mt-3 md:mt-6">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            10. Contact
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            For support or grievances, contact MNCL customer service or the
            Grievance Officer
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TermsAndConditionsPage;
